import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'

import type { MockServer } from './server.js'

export type OnlineBookingSettingsData = {
  department_id: number
  enabled: boolean
}

export const model = Model as ModelDefinition<OnlineBookingSettingsData>

export const factory = Factory.extend<OnlineBookingSettingsData>({
  department_id: 1,
  enabled: true,
})

export function routes(server: MockServer) {
  server.get('/settings/online_booking', (schema) =>
    schema.first('onlineBookingSettings'),
  )
}

export function seeds(server: MockServer) {
  server.create('onlineBookingSettings')
}
